var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-idle',{attrs:{"reminders":[300],"duration":1800},on:{"idle":_vm.onIdle,"remind":_vm.onRemind}}),_c('IdleWarningDialog',{ref:"idleWarning"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }